import axios from "axios";
import {Server} from "../constants";

export const adapter = async (endPoint, restMethod, body) => {
    var response = undefined;

    try {
        if (restMethod === "GET") {
            response = await axios.get(`${Server}${endPoint}`)
        } else if (restMethod === "POST") {
            response = await axios.post(`${Server}${endPoint}`, body)
        } else if (restMethod === "UPDATE") {
            response = await axios.put(`${Server}${endPoint}`, body)
        } else if (restMethod === "DELETE") {
            response = await axios.delete(`${Server}${endPoint}`, body)
        }
        if (response.request.status === 200) {
            return response.data;
        } else {
            return response;
        }
    } catch (err) {
        console.log(err)
        return response;
    }
}
